import axios from 'axios'
import { getUser } from './auth'

const BASE_URL = 'https://api-rfi.tianenusa.com'
// const BASE_URL = 'http://localhost:8080'

export { getFabricsOverview, getFabric, saveFabric }

function getRestOptions(token) {
  return {
    headers: {
      'Accept': 'application/json',
      'Authorization': `Bearer ${token}`
    }
  }
}

function getFabricsOverview() {
  const url = `${BASE_URL}/fabricsOverview`
  const token = JSON.parse(getUser()).token
  const options = getRestOptions(token)
  return axios.get(url, options).then(response => response.data)
}

function getFabric(articleId) {
  const url = `${BASE_URL}/fabrics/${articleId}`
  const token = JSON.parse(getUser()).token
  const options = getRestOptions(token)
  return axios.get(url, options).then(response => response.data)
}

function saveFabric(fabric, existing) {
  let url = `${BASE_URL}/fabrics`
  if (existing !== undefined && existing === true) {
    url = `${url}/${fabric.articleId}`
  }
  const token = JSON.parse(getUser()).token
  const options = getRestOptions(token)
  return axios.post(url, fabric, options)
}



// WEBPACK FOOTER //
// ./src/utils/rfi.js